import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type viewer from './viewer.vue'

export const viewerProps = buildProps({
  width: {
    type: Number,
    default: 1000,
  },
  height: {
    type: Number,
    default: 500,
  },
  minScale: {
    type: Number,
    default: 0.1,
  },
  maxScale: {
    type: Number,
    default: 5,
  },
  controlsPosition: {
    type: String,
    default: 'bottom',
    validator: (val: string) =>
      ['top', 'bottom', 'left', 'right'].includes(val),
  },
} as const)
export type ViewerProps = ExtractPropTypes<typeof viewerProps>
export type ViewerInstance = InstanceType<typeof viewer>
